import { ContentBlock } from "eddev/blocks"

const HTMLBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

export default {
  "core/rich-text": (props: ContentBlock) => {
    return <div className="core-rich-text" dangerouslySetInnerHTML={{ __html: props.innerHTML! }} />
  },
  // "core/paragraph": HTMLBlock,
  // "core/embed": (props) => {
  //   return <div>{JSON.stringify(props)}</div>
  // },
}
